// Stable browser/device fingerprint (hashed client-side). Used only for Alpha duplicate-account review.
const canvasSig = () => {
  try {
    const c = document.createElement("canvas");
    c.width = 220; c.height = 30;
    const g = c.getContext("2d");
    g.textBaseline = "top"; g.font = "14px 'Arial'"; g.fillStyle = "#f60"; g.fillRect(100, 1, 62, 20);
    g.fillStyle = "#069"; g.fillText("PacksSanctuary🐺,1.0", 2, 15);
    g.fillStyle = "rgba(102,204,0,0.7)"; g.fillText("PacksSanctuary🐺,1.0", 4, 17);
    return c.toDataURL().slice(-64);
  } catch { return ""; }
};

const webglSig = () => {
  try {
    const gl = document.createElement("canvas").getContext("webgl");
    const ext = gl && gl.getExtension("WEBGL_debug_renderer_info");
    return ext ? `${gl.getParameter(ext.UNMASKED_VENDOR_WEBGL)}~${gl.getParameter(ext.UNMASKED_RENDERER_WEBGL)}` : "";
  } catch { return ""; }
};

const fontSig = () => {
  try {
    const fonts = ["Arial", "Courier New", "Georgia", "Helvetica", "Segoe UI", "Roboto", "Ubuntu", "Menlo", "Tahoma", "Verdana"];
    return fonts.filter((f) => document.fonts && document.fonts.check(`12px "${f}"`)).join(",");
  } catch { return ""; }
};

let cached = null;

export async function getFingerprint() {
  if (cached) return cached;
  try {
    let tz = "";
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch { tz = ""; }
    const parts = [
      `${window.screen.width}x${window.screen.height}x${window.screen.colorDepth}`, tz,
      navigator.language, navigator.platform, navigator.hardwareConcurrency, navigator.deviceMemory,
      navigator.maxTouchPoints, canvasSig(), webglSig(), fontSig(),
    ].join("||");
    const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(parts));
    cached = Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
    return cached;
  } catch { return null; }
}
